import React, {useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LogoutModal from "../components/LogoutModal";
import Meta from "../components/Meta";
// eslint-disable-next-line
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../components/Loader";
import { Button } from "react-bootstrap";
import api from "../services/api";

const ChoisePassScreen = () => {

  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

   const submitHandler = async (e) => {
    try {
      e.preventDefault();
      if (password !== confirmPassword) {
        toast.error("Senhas não conferem");
      } else {
        setLoading(true);
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };
        // eslint-disable-next-line
        const { data } = await api.put(
          "/api/users",
          {
            password,
            numCpf:userInfo.cpf,
          },
          config
        );


        setPassword('');
        setConfirmPassword('');
       
        toast.success("Senha alterada com sucesso!");

        setLoading(false);
     
      }
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err);
    }
  };

  


  return (
    <>
      <ToastContainer />
      <Meta />

      <div id="wrapper">
        <Sidebar />

        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar />

            {loading ? (
              <Loader />
            ) : (
              <div className="container-fluid">
                <div className="d-sm-flex align-items-center justify-content-between mb-4">
                  <h1 className="h3 mb-0 text-gray-800">Trocar Senha</h1>
                </div>



                  {/* formulario de cadastro  */}

                  <form className="user" onSubmit={submitHandler}>
             
                        <div className="form-group row">
                          <div className="col-sm-6 mb-3 mb-sm-0">
                            <input
                              type="password"
                              className="form-control form-control-user"
                              id="senha"
                              placeholder="Entre com senha"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>
                          <div className="col-sm-6">
                            <input
                              type="password"
                              id="senha1"
                              className="form-control form-control-user"
                              placeholder="Repita a senha"
                              value={confirmPassword}
                              onChange={(e) =>
                                setConfirmPassword(e.target.value)
                              }
                            />
                          </div>
                        </div>

                        
                        <Button
                          type="submit"
                          className="btn btn-primary btn-user btn-block"
                         
                        >
                          Mudar Senha
                        </Button>
                      </form>

                      <hr />   






               
              </div>
            )}
          </div>

          <Footer />
        </div>
      </div>
      <LogoutModal />
    </>
  );
};

export default ChoisePassScreen;
